<template>
  <div>
    <v-row>
      <v-col lg="8" md="8" cols="12">
        <v-card outlined>
          <v-card-title class="d-flex">
            <span>Cadastro de Metas da Campanha</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  icon
                  :href="'https://www.youtube.com/watch?v=JfpyW1pEaa4'"
                  target="_blank"
                >
                  <v-icon>mdi-help-circle-outline</v-icon>
                </v-btn>
              </template>
              <span>Ajuda</span>
            </v-tooltip>
          </v-card-title>
          <v-card-text>
            <template v-if="onEdite">
              <p class="subtitle-1 mb-0">
                Cadastre as metas da campanha e defina os participantes de cada uma
              </p>
              <p class="caption">
                Em cada meta você configura o indicador, a forma de cálculo e o
                valor do bônus dos participantes
              </p>
            </template>
            <v-divider></v-divider>

            <!-- Público x Meta -->
            <v-card outlined class="mb-5">
              <v-card-title class="d-flex justify-space-between align-center">
                <span class="body-1 font-weight-bold">Público x Meta</span>
                <v-btn
                  color="primary"
                  small
                  @click="iniciarNovaMeta"
                  :disabled="!onEdite"
                >
                  <v-icon left small>mdi-plus</v-icon>Nova Meta
                </v-btn>
              </v-card-title>
              <v-divider></v-divider>
              <v-card-text>
                <div v-if="loadingMetas" class="d-flex justify-center py-8">
                  <v-progress-circular
                    indeterminate
                    color="primary"
                  ></v-progress-circular>
                </div>

                <div
                  v-else-if="metasRegistradas.length === 0"
                  class="d-flex flex-column align-center py-8"
                >
                  <v-icon size="52" color="grey lighten-2">mdi-target</v-icon>
                  <p class="body-2 grey--text mt-3 mb-1">
                    Nenhuma meta cadastrada
                  </p>
                  <p class="caption grey--text text--darken-1">
                    Clique em "Nova Meta" para começar
                  </p>
                </div>

                <ListaCardMetas
                  v-else
                  :metas="metasRegistradas"
                  :campanha="campanha"
                  :array-fechamentos-semanal="arrayFechamentosSemanal"
                  :metas-colaborador="metasColaborador"
                  :on-edite="onEdite"
                  @editar-meta="abrirEdicaoMeta"
                  @excluir-meta="excluirMeta"
                />
              </v-card-text>
            </v-card>

            <ModalCadastroMeta
              v-model="dialogNovaMeta"
              :meta-em-edicao="metaEmEdicao"
              :campanha="campanha"
              :metas-registradas="metasRegistradas"
              :array-fechamentos-semanal="arrayFechamentosSemanal"
              :periodos-media="periodosMedia"
              :faixas-media="faixasMedia"
              :metas-colaborador="metasColaborador"
              @meta-salva="carregarMetasCadastradas"
            />
          </v-card-text>
        </v-card>
      </v-col>
      <v-col lg="4" md="4" cols="12">
        <ResumoCampanhaCard
          :etapa="3"
          :id-campanha="$route.params.idCampanha"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import campanhaService from "@/services/campanha";
import comissao from "@/services/http/comissaoService";
import { getApiError } from "@/services/http";
import campanhas from "@/services/http/campanhaService";
import { mapGetters } from "vuex";
import ResumoCampanhaCard from "@/components/campanha/cadastro/ResumoCampanhaCard";
import ListaCardMetas from "./ListaCardMetas";
import ModalCadastroMeta from "./ModalCadastroMeta";

export default {
  name: "SectionPublicoMeta",

  props: {
    onEdite: {
      type: Boolean,
      default: true
    }
  },

  components: {
    ResumoCampanhaCard,
    ListaCardMetas,
    ModalCadastroMeta
  },

  data() {
    return {
      campanha: {},
      dialogNovaMeta: false,
      metaEmEdicao: null,
      loadingMetas: false,
      metasRegistradas: [],
      // Mapa { id_campanha_meta: [{ ano_ref, mes_ref }] }, devolvido pela API
      // fora das linhas (uma vez por meta, nao por linha x colaborador) —
      // ver carregarMetasCadastradas abaixo e o de-para de leitura em
      // ModalCadastroMeta.editarMeta.
      periodosMedia: {},
      // Mapa { id_campanha_meta: [{ faixa_de, faixa_ate, percentual_crescimento }] },
      // mesmo padrao de periodosMedia — so tem conteudo quando o crescimento
      // da media e Progressivo por faixa. Ver ModalCadastroMeta.editarMeta.
      faixasMedia: {},
      // Mapa { id_campanha_meta: [{ id_colaborador, id_empresa, valor_meta,
      // valor_media_referencia, meta_manual, valor_bonus }] }, mesmo padrao de
      // periodosMedia (irmao de data, chave ausente quando a meta nao tem
      // participante) — ver ModalCadastroMeta.editarMeta.
      //
      // valor_bonus (Fase 5) e o bonus gravado de cada participante na origem
      // "% sobre referencia". E por causa dele que esta tela nao busca mais a
      // comissao P2: o valor ja vem pronto, e a apuracao o mantem atualizado.
      metasColaborador: {},
      arrayFechamentosSemanal: []
    };
  },

  async mounted() {
    await this.initializeEmpresasParticipantes();
    const { data } = await campanhaService.getById(
      this.$route.params.idCampanha
    );
    this.campanha = data;
    if (data.id_tipo_dado === "C") {
      await this.carregarSemanasCampanha();
    }
    this.carregarMetasCadastradas();
  },

  computed: {
    ...mapGetters({
      getMetasCadastradas: "campanha/getMetasCadastradas",
      getEmpresasParticipantes: "campanha/getEmpresasParticipantes"
    }),

  },

  methods: {
    async initializeEmpresasParticipantes() {
      if (!this.getEmpresasParticipantes.length) {
        await this.$store.dispatch(
          "campanha/actionEmpresasParticipantes",
          this.$route.params.idCampanha
        );
      }
    },

    async carregarSemanasCampanha() {
      try {
        const d = this.campanha.data_inicio || "";
        const { data } = await comissao().tipoFechamento().show({
          id_tipo_dado: "C",
          id_tipo_evento: "M",
          mes_ref: d.substr(5, 2),
          ano_ref: d.substr(0, 4)
        });
        const semanas = data.data || [];
        semanas.sort((a, b) => new Date(a.data_final) - new Date(b.data_final));
        this.arrayFechamentosSemanal = semanas;
      } catch (e) {
        // silently fail — custo será calculado sem multiplicador semanal
      }
    },

    iniciarNovaMeta() {
      this.metaEmEdicao = null;
      this.dialogNovaMeta = true;
    },

    abrirEdicaoMeta(meta) {
      this.metaEmEdicao = meta;
      this.dialogNovaMeta = true;
    },

    async carregarMetasCadastradas() {
      this.loadingMetas = true;
      try {
        const res = await campanhas().metasCampanha().show({ id_campanha: this.$route.params.idCampanha, per_page: -1 });
        this.metasRegistradas = Array.isArray(res?.data) ? res.data : res?.data?.data || [];
        // So existe quando res.data e um objeto (nao o array puro do formato
        // antigo/paginado sem envelope) — meta antiga ou resposta antiga cai
        // no default {} e editarMeta usa o fallback de mesesReferencia vazio.
        this.periodosMedia = (!Array.isArray(res?.data) && res?.data?.periodos_media) || {};
        this.faixasMedia = (!Array.isArray(res?.data) && res?.data?.faixas_media) || {};
        this.metasColaborador = (!Array.isArray(res?.data) && res?.data?.metas_colaborador) || {};
        this.$store.commit("campanha/setMetasCadastradas", {
          data: this.metasRegistradas
        });
      } catch (e) {
        this.$notify({
          type: "error",
          text: getApiError(e, "Erro ao carregar metas")
        });
      } finally {
        this.loadingMetas = false;
      }
    },

    async excluirMeta(meta) {
      try {
        await this.$swal.confirm(
          "Deseja excluir esta meta?",
          "Excluir Meta",
          "Excluir",
          "Cancelar"
        );
      } catch {
        return;
      }
      try {
        await campanhas().metasCampanha(meta.id_campanha_meta).delete();
        await this.carregarMetasCadastradas();
        this.$notify({ type: "success", text: "Meta excluída com sucesso" });
      } catch (e) {
        this.$notify({ type: "error", text: getApiError(e, "Erro ao excluir meta") });
      }
    },

  }
};
</script>
